<template>
  <div class="flex flex-col h-full">
    <div class="w-full h-full flex-1 flex flex-col items-center text-white">
      <template v-if="sharedData.showAmount === 2">
        <Image class="size-[58px] mt-[80px]" :src="success" alt="" />
        <span class="text-[#64F765] text-[25px] font-bold mt-[20px]">
          R$ {{ formatNumber(sharedData?.amount) }}
        </span>
        <span class="text-[12px] mt-6 leading-[14px] text-[#95979b]">
          {{ $t('Saque.SaqueSuccess.OrderNumber') }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ sharedData.orderNo }}
        </span>
        <div class="text-[20px] mt-[15px] mb-[10px]">{{ $t('Saque.SaqueSuccess.WithdrawalRequestSent') }}</div>
        <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
          {{ $t('Saque.SaqueSuccess.WithdrawalSuccessMessage') }}
        </div>
        <button
          @click="navigateHome"
          class="w-[356px] h-[44px] text-[15px] border-none text-[#151A1F] font-bold rounded-[8px] bg-[#64F765] mt-[30px]"
        >
          {{ $t('Saque.SaqueSuccess.BackToHome') }}
        </button>
      </template>
      <template v-if="sharedData.showAmount === 3">
        <Image class="size-[58px] mt-[80px]" :src="fail" alt="" />
        <span class="text-[#64F765] text-[25px] font-bold mt-[20px]">
          R$ {{ formatNumber(sharedData?.amount) }}
        </span>
        <span class="text-[12px] mt-6 leading-[14px] text-[#95979b]">
          {{ $t('Saque.SaqueSuccess.OrderNumber') }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ sharedData?.orderNo }}
        </span>
        <div class="text-[20px] mt-[25px] mb-[10px]">{{ $t('Saque.SaqueSuccess.WithdrawalRequestFailed') }}</div>
        <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
          {{ $t('Saque.SaqueSuccess.WithdrawalFailedMessage') }}
        </div>
        <div
          @click="navigateCustomerService"
          class="text-[14px] flex items-center gap-2 mt-6 text-center px-[50px] leading-[16px] text-white/70"
        >
          <Image class="size-[24px] mr-2" :src="customerService" alt="" />
          <span class="text-[#64F765]">{{ $t('Saque.SaqueSuccess.CustomerService') }}</span>
        </div>
        <button
          @click="navigateHome"
          class="w-[356px] h-[44px] border-none text-[15px] text-[#151A1F] font-bold rounded-[8px] bg-[#64F765] mt-[30px]"
        >
          {{ $t('Saque.SaqueSuccess.BackToHome') }}
        </button>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { formatNumber } from "@/utils";
import success from "@/themes/theme_a/views/Saque/images/success.png";
import fail from "@/themes/theme_a/views/Saque/images/fail.png";
import customerService from "@/themes/theme_a/views/Saque/images/customerService.png";
const router = useRouter();

const sharedData: any = inject("sharedData");
const navigateHome = () => {
  router.push("/");
};
const navigateCustomerService = () => {
  router.push("/servico");
};
</script>
<style lang="scss" scoped></style>
